import classNames from 'classnames';
import * as React from 'react';
import { IsMobileDevice } from 'source/app/domain/Device/Helpers/IsMobile';
import { TRenderable } from '../SharedTypes';
import { StyleClass } from '../Styles/CSS';
import { IAnimationData } from './AnimationFactory';

export function Animate({
	animation,
	playImmediately,
	playOnClick,
	children
}: {
	animation: IAnimationData;
	playImmediately: boolean;
	playOnClick?: boolean;
	children: TRenderable;
}) {
	if (IsMobileDevice()) {
		return <span>{children}</span>;
	}

	const [ animationClass, setAnimationClass ] = React.useState(``);
	const preRequisiteStylesClass = StyleClass(`prerequisiteStyles`, { ...animation.prerequisiteStyles });

	const Animate = () => {
		const isAnimationRunning = animationClass !== ``;

		if (!isAnimationRunning) {
			const animationClass = StyleClass(`animation`, animation.effects.entering);
			setAnimationClass(animationClass);
			const stopAnimationAfterMs = animation.duration + animation.delay;
            
            if (!animation.playInfinitely) {
                setTimeout(() => setAnimationClass(``), stopAnimationAfterMs);
            }
		}
	};

	React.useEffect(
		() => {
			if (playImmediately) {
				Animate();
			}
		},
		[ children ]
	);

	return (
		<span
			id={`${animation.name}-animation`}
			className={classNames(preRequisiteStylesClass, animationClass)}
			onClick={playOnClick ? () => Animate() : () => {}}
		>
			{children}
		</span>
	);
}
